import React, { Component } from 'react';
import { RadialBarChart, RadialBar, Legend, ResponsiveContainer } from 'recharts';
import StatisticService from '../services/StatisticService';

const style = {
  top: '50%',
  right: 0,
  transform: 'translate(0, -50%)',
  lineHeight: '24px',
};

class ReportRada extends Component {
  constructor() {
    super();
    this.state = {
      data: []
    }
  }

  componentDidMount () { 
    this.loadData();
  }

  loadData() {
    StatisticService.getGhiLoiStatistics().then(data => {
      if (data !== undefined && data !== null && data instanceof Array) {
        this.setState({ data: data })
      }
    });
  }

  render() {
    const { data } = this.state;
    return (
      <ResponsiveContainer width="70%" aspect={3}>
        <RadialBarChart cx="50%" cy="50%" innerRadius="10%" outerRadius="80%" barSize={10} data={data}>
          <RadialBar
            minAngle={15}
            label={{ position: 'insideStart', fill: '#fff' }}
            background
            clockWise
            dataKey="count"
          />
          <Legend iconSize={10} layout="vertical" verticalAlign="middle" wrapperStyle={style} />
        </RadialBarChart>
      </ResponsiveContainer>
    );
  }
}

export default ReportRada;